import { fetchApi } from 'Utils/utils';

let search = function(payload) {
  return fetchApi.post('/api/v1/userSession/search/', payload);
};

export { search };
